// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type ProjectResponse,
  ProjectResponseFromJSON,
  ProjectResponseToJSON,
} from "../models/ProjectResponse";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface FolderTemplateRetrieveRequest {
  /**
   *
   */
  tenantId: string;
}

/**
 *
 */
export class FolderTemplatesApi extends runtime.BaseAPI {
  /**
   * Creates request options for folderTemplateRetrieve without sending the request
   */
  async folderTemplateRetrieveRequestOpts(
    requestParameters: FolderTemplateRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling folderTemplateRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/folder-template`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return the hidden template project for the tenant, creating it if it does not yet exist. Use the returned project ID with the standard project files endpoints to manage the folder structure that is automatically applied to every newly created project.
   * retrieve folder template project
   */
  async folderTemplateRetrieveRaw(
    requestParameters: FolderTemplateRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<ProjectResponse>> {
    const requestOptions = await this.folderTemplateRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => ProjectResponseFromJSON(jsonValue));
  }

  /**
   * Return the hidden template project for the tenant, creating it if it does not yet exist. Use the returned project ID with the standard project files endpoints to manage the folder structure that is automatically applied to every newly created project.
   * retrieve folder template project
   */
  async folderTemplateRetrieve(
    requestParameters: FolderTemplateRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<ProjectResponse> {
    const response = await this.folderTemplateRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
